module.exports = __webpack_public_path__ + "media/images/linkedin-5b0cd0ae581983d79283bb1d26421545.gif";